<template>
  <v-container class="w-auto mx-15" fluid>
    <v-row align="start" justify="center" class="d-flex align-self-start w-100">
      <v-col>
        <AdminDataTableHeader
            :table-model="tableModel"
            :is-user="false"
            :create-action="createContragent"
        />

        <AdminDataTable
          :keys-table-model="KeysTableModel"
          :table-model="tableModel"
          :subject="'c'"
          :view="viewContragent"
          :edit="editContragent"
          :viewStaffs="viewStaffs"
          :switchStatus="switchStatusContragent"
        >
          <template v-slot:item.c.status="{ value }">
            <eventStatus
                :isSuccess="statusHelper.getStatus(value)"
                :value="statusHelper.getStatusLabel(value)"
            />
          </template>
        </AdminDataTable>
      </v-col>
    </v-row>
  </v-container>

  <ConfirmDialog ref="confirm" />
</template>

<script>
import api from '@/api';
import { toast } from '@/lib/toast';
import RemoteTableModel from '@/components/RemoteTableModel';
import AdminDataTable from "@/components/AdminDataTable.vue";
import AdminDataTableHeader from "@/components/AdminDataTableHeader.vue";
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";
import { getStatusLabel, getStatus } from '@/lib/statusHelper';
import eventStatus from "@/components/eventStatus.vue";

export default {
  components: {eventStatus, AdminDataTable, ConfirmDialog, AdminDataTableHeader },
  data() {
    const tableModel = new RemoteTableModel({
      headers: [
        { title: 'Наименование', key: 'c.fullName', width: '8%' },
        { title: 'Регистрация', key: 'c.accreditation', width: '6%' },
        { title: 'CRN', key: 'c.inn', width: '18%' },
        { title: 'Телефон', key: 'c.phone', sortable: false, width: '6%' },
        { title: 'Адрес электронной почты', key: 'c.email', sortable: false, width: '8%'},
        { title: 'Статус', key: 'c.status', width: '8%' },
        { title: '', key: 'actions', sortable: false, width: '6%' },
      ],
      loader(query) {
        return api.get('/admin/contragents', { query: JSON.stringify(query) });
      },
      options: {
        itemsPerPage: 10,
      },
    });
    return {
      tableModel: tableModel,
      KeysTableModel: tableModel.bind.headers.map(header => header.key),
      statusHelper: {
        getStatusLabel: getStatusLabel,
        getStatus: getStatus
      }
    };
  },
  methods: {
    viewContragent(item) {
      this.$router.push({
        name: 'admin.contragents.view',
        params: { id: item.id },
      });
    },
    viewStaffs(item) {
      const query = {
        inn: item.c.inn
      }
      if (item.c.kpp) {
        query.kpp = item.c.kpp;
      }
      if (item.c.ogrn) {
        query.ogrn = item.c.ogrn;
      }

      this.$router.push({
        name: 'users.all',
        query: query
      });
    },
    createContragent() {
      this.$router.push({
        name: 'admin.contragents.create',
        params: { id: null },
      });
    },
    editContragent(item) {
      this.$router.push({
        name: 'admin.contragents.edit',
        params: { id: item.id }
      });
    },
    async switchStatusContragent(contragent, mode) {
      const { id, fullName } = contragent;
      let resultDialog = true;

      if (mode === 'blocked') {
        resultDialog = await this.$refs.confirm.open(
          'Блокирование организации',
          `Вы уверены, что хотите заблокировать организацию ${fullName}?<br>Все пользователи организации также будут заблокированы.`,
        ); 
      } else if (mode === 'unblocked') {
        resultDialog = await this.$refs.confirm.open(
          'Разблокирование организации',
          `Вы уверены, что хотите разблокировать организацию ${fullName}?<br>Все пользователи организации также будут разблокированы.`,
        ); 
      }

      if (resultDialog) {
        try {   
          await api.get(`/admin/contragents/${id}/switchStatus`, {'mode': mode});
          this.tableModel.reload();
        } catch (e) {
          toast.error(e.message);
        }
      }
    },

    async downloadRegistry() {
      window.location.href = '/admin/getContragentsInXlsx';
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-field) {
  padding: 0;
  font-family: var(--primary-font-family-name);
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  box-shadow: none;
}

:deep(.v-field__input) {
  display: block;
  padding: 0;
  width: 48px;
  height: 34px;
  min-height: 0;
}

:deep(.v-field__prepend-inner) {
  padding-left: 5px;
}
</style>